export const TOP_SEARCH_VALUE = "TOP_SEARCH_VALUE";
export const SELECTED_ITEM = "SELECTED_ITEM";
export const TOP_SEARCH_CLICK = "TOP_SEARCH_CLICK";
